import { Button } from 'antd'
import { useRouter } from 'next/router'
import { FunctionComponent, useEffect } from 'react'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'
import errorImgSrc from '@/assets/images/cosmos.png'
import { useIntl } from '@/i18n/hooks/use-intl'
import { ampli } from '@/utils/ampli'

export interface CardErrorCosmosProps {
  className?: string
  onReset?: () => void
  size?: 'small' | 'large'
}

const CardErrorCosmos: FunctionComponent<CardErrorCosmosProps> = ({
  className,
  onReset,
  size = 'large',
}) => {
  const { formatMessage } = useIntl()
  const router = useRouter()
  const onReload: VoidFunction = () => {
    ampli.refreshPage({ path: router.asPath })
    location.reload()
  }

  useEffect(() => {
    if (!onReset) {
      return
    }
    router.events.on('routeChangeComplete', onReset)
    return () => {
      router.events.off('routeChangeComplete', onReset)
    }
  }, [router.events, onReset])

  return (
    <Wrapper className={className} size={size}>
      <StyledImage src={errorImgSrc} />
      <TextWrapper>
        <CardErrorCosmosTitle>
          {formatMessage({ id: 'error:something_wrong_title' })}
        </CardErrorCosmosTitle>
        <SubTitle>
          {formatMessage({ id: 'error:refresh_again_try_again' })}
        </SubTitle>
        <Button type='primary' onClick={onReload}>
          {formatMessage({ id: 'error:error_page_refresh_button' })}
        </Button>
      </TextWrapper>
    </Wrapper>
  )
}

export const CardErrorCosmosTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }): string => theme.colors.gray10};
`

const SubTitle = styled.div`
  color: black;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  word-wrap: break-word;
`

const StyledImage = styled.img`
  width: 320px;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  button {
    margin-top: 30px;
  }
`

const Wrapper = styled.div<{ size?: 'small' | 'large' }>`
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${TextWrapper} {
    margin-top: 20px;
  }

  ${({ size }): FlattenSimpleInterpolation =>
    size === 'small'
      ? css`
          flex-direction: column;
          ${TextWrapper} {
            align-items: center;
          }
          ${StyledImage} {
            width: 250px;
            wmargin-right: 40;
          }
        `
      : css``}
`

export default CardErrorCosmos
